import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';

import { SearchLoadWrapper } from '../LiveSearchElementStructure.tsx';

export const SearchLoading = () => (
	<SearchLoadWrapper>
		<Spinner size="small" />
	</SearchLoadWrapper>
);
